// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__gq7Vj","left":"StickyBox_left__NlS7l","right":"StickyBox_right__2sY6d"};